module.exports = __webpack_public_path__ + "img/Vionvision.9730ef98.jpg";